import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {StepLabel} from "@mui/material";

const CustomStepper = ({
                           steps,
                           activeStep,
                           completed,
                           handleStep
                       }: {
    steps: string[];
    activeStep: number;
    completed: { [k: number]: boolean };
    handleStep: (index: number) => void;
}) => (
    <Stack sx={{width: "100%"}}>
        <Stepper nonLinear activeStep={activeStep} sx={{width: "100%"}}>
            {steps.map((label, index) => (
                <Step
                    completed={completed[index]}
                    key={label}
                    onClick={() => handleStep(index)}
                    style={{
                        color: activeStep === index ? "#c8017d" : "#dde0e7",
                        cursor: "pointer",
                        width: `calc(100% / ${steps.length})`
                    }}
                >
                    <StepLabel
                        StepIconComponent={() =>
                            completed[index] ? (
                                <CheckCircleIcon color="inherit" style={{fontSize: 20}}/>
                            ) : (
                                <StepButton color="inherit"/>
                            )
                        }
                        style={{justifyContent: "space-between"}}
                    >
                        {label}
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    </Stack>
);

export default CustomStepper;
